import CostIcon from '../../../assets/icons/CostIcon.svg?react';
import CardHeader from "./common/CardHeader";
import ViewAllArrowIcon from '../../../assets/icons/ViewAllArrowIcon.svg?react';
import { useSuperDashboardContext } from "../superdashboard/context/SuperDashboardContext";
import { COMPANY_MODAL_KEYS } from "../../../utils/enum";
import { pieViewAllClasses, statCardClasses } from '../../../components/common/dashboardClasses';
import { costTotalTextClasses, costAmountClasses } from '../../../components/common/dashboardGridClasses';

const customerTextClasses = 'text-content font-heading text-sm font-normal not-italic leading-5';
const customerItemClasses = 'text-subtle font-heading text-sm font-normal not-italic leading-normal flex items-center';

const costItemClasses =
    'flex justify-between items-center self-stretch p-4 rounded bg-surface-alt';

const LLMCostByCustomer = () => {
    const { companiesCostData, totalCostCount, openModalByKey } = useSuperDashboardContext();

    const rightSection = (
        <div className={costTotalTextClasses}>
            <span>Total Cost</span>
            <span className={`${costAmountClasses} ml-2!`}>
                ${Number(totalCostCount).toFixed(2)}
            </span>
        </div>
    );
    return (
        <div className={statCardClasses}>
            <CardHeader
                icon={<CostIcon />}
                title="LLM Cost by Customer"
                rightContent={rightSection}
            />

            {companiesCostData?.slice(0, 5).map((company, i) => (
                <div
                    key={company.companyId}
                    className={costItemClasses}
                >
                    <div className={customerTextClasses}>
                        {i + 1}. {company.companyName}
                    </div>
                    <div className={customerItemClasses}>
                        <span>{company.totalDemands} Demands Generated</span>
                        <div className="vr mx-4"></div>
                        <span className="ml-2!">{company.totalCases} Cases</span>
                        <span className="mx-6 amount">
                            ${Number(company.totalCostPerCompany).toFixed(2)}
                        </span>
                    </div>
                </div>
            ))}
            <div className="mt-3">
                <span onClick={() => openModalByKey(COMPANY_MODAL_KEYS.COST)} className={pieViewAllClasses}>View All <ViewAllArrowIcon className="text-primary" /></span>
            </div>
        </div>
    );
};

export default LLMCostByCustomer;
